export default "assets/images/texture_beige-1268c6e3.jpg";